import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox  from '@material-ui/core/Checkbox';
import {Tooltip} from "@material-ui/core";
import {useStylesTooltip} from "../../../../../../config/theme";

const useStyles = makeStyles(() => ({
  root: {
    marginLeft: 3,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    borderRadius: 3,
    width: 19.11,
    height: 18,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    backgroundSize: 'contain',
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
  },
  checkedIcon: {
    // backgroundColor: '#137cbd',
    boxShadow: 'none',
    backgroundImage: "url('/assets/icons/checked.svg')",
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    '&:before': {
      display: 'block',
      width: 19.11,
      height: 18,
      backgroundRepeat: 'no-repeat',
      backgroundImage: "url('/assets/icons/checked.svg')",
      backgroundSize: 'contain',
      content: '""',
    },
    'input:hover ~ &': {
      // backgroundColor: '#106ba3',
    },
  },
}));

function StyledCheckbox(props: any) {
  const classes = useStyles();
  const { isheader } = props;
  const tooltipClasses = useStylesTooltip();

  return (
    isheader ? (
      <Tooltip classes={tooltipClasses} title="Manage Participants" placement="bottom" arrow>
        <Checkbox
          className={classes.root}
          disableRipple
          color="default"
          checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
          icon={<span className={classes.icon} />}
          {...props}
        />
      </Tooltip>
    ) : (
      <Checkbox
        className={classes.root}
        disableRipple
        color="default"
        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
        icon={<span className={classes.icon} />}
        {...props}
      />
    )
  );
}

export default function CustomizedCheckbox(props: any) {
  return (
    <div>
      <StyledCheckbox {...props} />
    </div>
  );
}
